// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"3fc0c112","245":"3fc0c112","668":"3fc0c112","778":"3fc0c112"}[chunkId] + ".chunk.css";
};